import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var AlignRight02 = function AlignRight02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 8.3978 21 7.9319 21 7s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 4 18.9319 4 18 4h-8c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C7 5.6022 7 6.0681 7 7s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C8.6022 10 9.0681 10 10 10zm0 10c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 18.3978 21 17.9319 21 17s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 14 18.9319 14 18 14H6c-.9319 0-1.3978 0-1.7654.1522-.49.203-.8794.5924-1.0824 1.0824C3 15.6022 3 16.0681 3 17s0 1.3978.1522 1.7654c.203.49.5924.8794 1.0824 1.0824C4.6022 20 5.0681 20 6 20z"
    })
  }));
};
export default AlignRight02;